<template>
  <div style="margin-top: 350px">
    <div id="test-notification-buttons">
      <button class="btn btn-info" v-on:click="handleNotificationModalInfo">Notification Modal Info</button>
      <button class="btn btn-warning" v-on:click="handleNotificationModalWarning">Notification Modal Warning</button>
      <button class="btn btn-primary" v-on:click="handleCloseAllFlashNotifications">Close notifications</button>
      <button class="btn btn-primary" v-on:click="showAllFlashNotifications">Show notifications</button>
    </div>
    <div>
      <notification-component :modal-state="modalState"></notification-component>
      <notifications classes="notification-broadcast" group="test"></notifications>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalState: false,
    };
  },
  methods: {
    handleNotificationModalInfo: function () {
      const notification = {
        data: {
          category: 'info',
          title: 'Lorem ipsum',
          message: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.'
        }
      };
      this.$store.commit('notifications/addNotification', notification).then(() => this.modalState = true);
    },
    handleNotificationModalWarning: function () {
      const notification = {
        data: {
          category: 'warning',
          title: 'Lorem ipsum',
          message: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.'
        }
      };
      this.$store.commit('notifications/addNotification', notification).then(() => this.modalState = true);
    },
    handleCloseAllFlashNotifications: function () {
      this.$notify({
        group: 'test',
        clean: true
      });
    },
    showAllFlashNotifications: function () {
      const options = {
          group: 'test',
          title: 'Lorem ipsum',
          text: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.',
          duration: -1,

        },
        types = ['info', 'warn', 'error', 'success'];

      types.forEach((type) => {
        this.$notify({
          ...options,
          type: type,
        });
      });
    },
  },
  mounted() {
    this.showAllFlashNotifications();
  }
};
</script>
